import Dashboard from './dashboard/index';

import Footer from './footer/script';
import Header from './header/script';
import LoginForm from './login-form/script';
import ProjectList from './project-list/script';


export default {
	...Dashboard,

	[Footer.selector]: Footer,
	[Header.selector]: Header,
	[LoginForm.selector]: LoginForm,
	[ProjectList.selector]: ProjectList
};
